import _ from 'lodash'

import type { DigitalProduct } from '@/types/digitalProduct'

import { EventLogo } from '@/shared/ui/EventLogo'

import { resolveAuthTagline } from './auth-branding'

type AuthBrandingCompactProps = {
  digitalProduct?: DigitalProduct
}

/**
 * Identidade do evento nas sub-rotas.
 *
 * O hero de sign-in já é alto (logo em evidência + value props). Nas demais
 * rotas de auth, esta versão traz o que identifica o evento e nada além: logo
 * em destaque e tagline — sem empurrar o formulário para fora da dobra em 375px.
 *
 * Sem isso, sair de `/auth/sign-in` para qualquer sub-rota fazia a tela perder
 * toda a marca do evento e virar uma página genérica de plataforma.
 */
export function AuthBrandingCompact({ digitalProduct }: AuthBrandingCompactProps) {
  const logoUrl = _.get(digitalProduct, 'logo.file.url') as string | undefined
  const tagline = resolveAuthTagline(digitalProduct)

  if (!logoUrl && !tagline) return null

  return (
    <header className="mb-5 flex w-full flex-col items-center gap-2 text-center">
      {logoUrl ? (
        <EventLogo src={logoUrl} alt="" variant="auth-compact" />
      ) : null}
      {tagline ? (
        <p className="line-clamp-2 text-sm font-semibold leading-snug text-gray-700">
          {tagline}
        </p>
      ) : null}
    </header>
  )
}
